window.onload = function(event) {
    function addMenuClickListener() {

        const sidebar = document.querySelector(".sidebar__body");

        if (!sidebar) {
            console.warn("Sidebar not found!");
            return;
        }

        sidebar.addEventListener("click", function (event) {
            const menuLink = event.target.closest(".menu__item.has-sub a.menu__link");

            if (menuLink) {
                event.preventDefault();

                const parentMenuItem = menuLink.parentElement;
                if (parentMenuItem) {
                    parentMenuItem.classList.toggle("open");
                }
            }
        });
    }

    if (document.querySelector(".sidebar__body")) {
        addMenuClickListener();
    }

    // const observer = new MutationObserver((mutationsList) => {
    //     for (let mutation of mutationsList) {
    //         if (mutation.type === "childList") {
    //             if (document.querySelector(".sidebar__body")) {
    //                 addMenuClickListener();
    //                 observer.disconnect();
    //                 break;
    //             }
    //         }
    //     }
    // });
    //
    // observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener("beforeunload", function () {
        let getlistTabIds = localStorage.getItem("listTabIDs") || "";
        let currentTabID = sessionStorage.tabID;
        sessionStorage.closedLastTab = "1";

        let listTabIdsN = getlistTabIds.replace("," + currentTabID, "").replace(currentTabID, "");
        listTabIdsN = listTabIdsN.replace(/^,+/, "").replace(/,+$/, ""); // Xóa dấu phẩy đầu và cuối

        localStorage.setItem("listTabIDs", listTabIdsN);
    });

    function setNewID() {
        let oldID = sessionStorage.tabID;
        let getlistTabIds = localStorage.getItem("listTabIDs") || "";
        let listTabIdOther = getlistTabIds.replace("," + oldID, "").replace(oldID, "");
        let arrID = listTabIdOther.split(",");
        let newID = rollNewID(arrID);

        sessionStorage.tabID = newID;

        if (window.listTabIds === undefined) {
            window.listTabIds = newID;
            localStorage.setItem("listTabIDs", window.listTabIds);
        } else {
            if (!window.listTabIds.includes(newID)) {
                window.listTabIds += "," + newID;
                window.listTabIds = window.listTabIds.replace(/^,+/, "").replace(/,+$/, "");
                localStorage.setItem("listTabIDs", window.listTabIds);
            }
        }
    }

    function rollNewID(listID) {
        let id = Math.random();
        return listID.includes(id) ? rollNewID(listID) : id;
    }

    window.listTabIds = localStorage.getItem("listTabIDs");
    setNewID();

    // Cập nhật chiều cao viewport tùy chỉnh
    function updateVH() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
    updateVH();
    window.addEventListener("resize", updateVH);

    // Xử lý toggle sidebar
    const headerToggle = document.querySelector(".header__toggle");
    const sidebarToggle = document.querySelector(".sidebar");
    const closeSidebarToggle = document.querySelector(".close-sidebar");
    if (headerToggle) {
        headerToggle.addEventListener("click", function () {
            const body = document.body;
            const sidebar = document.querySelector(".sidebar");
            const collapsed = body.classList.toggle("sidebar-collapse");

            if (sidebar) {
                sidebar.classList.toggle("closed", collapsed);
            }

            localStorage.setItem("sidebar-toggle-collapsed", collapsed ? "1" : "0");

            sidebarToggle.classList.add("closed");
            sidebarToggle.classList.remove("closed");
        });
    }

    if(closeSidebarToggle){
        closeSidebarToggle.addEventListener("click", function () {
            sidebarToggle.classList.add("closed");
            sidebarToggle.classList.remove("open");
        });
    }

    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("header__toggle")) {
            console.log("Bạn đã click vào nút toggle!");
        }
    });



    // Phục hồi trạng thái sidebar
    if (localStorage.getItem("sidebar-toggle-collapsed") === "1") {
        document.body.classList.add("sidebar-collapse");
        const sidebar = document.querySelector(".sidebar");
        if (sidebar) {
            sidebar.classList.add("closed");
        }
    }

    // Xử lý click ngoài sidebar để đóng
    const overlay = document.querySelector(".overlay");
    if (overlay) {
        overlay.addEventListener("click", function () {
            document.body.classList.add("sidebar-collapse");
        });
    }

    // Kiểm tra màn hình khi resize
    function checkScreen() {
        let width = window.innerWidth;
        let body = document.body;
        if (width >= 992) {
            body.classList.add("sidebar-mini");
        } else {
            body.classList.add("sidebar-collapse");
            body.classList.remove("sidebar-mini");
        }
    }
    checkScreen();
    window.addEventListener("resize", checkScreen);


    // Ngăn dropdown menu bị đóng khi click
    document.querySelectorAll(".dropdownCompany-menu").forEach((menu) => {
        menu.addEventListener("click", function (event) {
            event.stopPropagation();
        });
    });

    // Đóng/mở thanh lọc nâng cao (Advanced Filter)
    const advFilterClose = document.querySelector("#adv-filter .adv-filter .btn--close");
    if (advFilterClose) {
        advFilterClose.addEventListener("click", function () {
            document.querySelector("#adv-filter .adv-filter").classList.add("el-invisible");
        });
    }

    const advSearchButton = document.querySelector(".button--adv-search");
    if (advSearchButton) {
        advSearchButton.addEventListener("click", function () {
            document.querySelector("#adv-filter .adv-filter").classList.remove("el-invisible");
        });
    }

    // Định dạng input trong Advanced Filter
    document.querySelectorAll("#adv-filter .adv-filter input:not([type='checkbox'])").forEach((input) => {
        input.addEventListener("focusout", function () {
            if (this.value === "") {
                this.style.width = "100%";
                this.classList.remove("format-input");
            } else {
                this.style.width = `${this.value.length}ch`;
                this.classList.add("format-input");
            }
        });
    });

    const btnAddApp = document.getElementById("addButton");
    if(btnAddApp){
        btnAddApp.addEventListener("click", function () {
            let userInput = document.getElementById("userInput").value;
            if (userInput.trim() !== "") {
                alert("Bạn đã nhập: " + userInput);
                // Đóng modal sau khi nhấn Add
                let myModal = new window.bootstrap.Modal(document.getElementById("myModal"));
                myModal.hide();
            } else {
                alert("Vui lòng nhập nội dung!");
            }
        });
    }


    // Xử lý sự kiện resize
    window.addEventListener("resize", function () {
        if (window.innerWidth > 991.98) {
            document.querySelectorAll(".sidebar").forEach((sidebar) => {
                sidebar.classList.remove("open");
            });
        } else {
            document.querySelectorAll(".sidebar").forEach((sidebar) => {
                sidebar.classList.add("closed");
            });
        }
    });

};


